var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.0409 41.9687L31.627 32.5547M31.627 32.5547C33.2373 30.9444 34.5146 29.0327 35.3861 26.9288C36.2576 24.8248 36.7062 22.5698 36.7062 20.2925C36.7062 18.0152 36.2576 15.7602 35.3861 13.6563C34.5146 11.5523 33.2373 9.64063 31.627 8.03034C30.0167 6.42004 28.105 5.14269 26.001 4.2712C23.8971 3.39972 21.6421 2.95117 19.3648 2.95117C17.0875 2.95117 14.8325 3.39972 12.7285 4.2712C10.6246 5.14269 8.7129 6.42004 7.1026 8.03034C3.85047 11.2825 2.02344 15.6933 2.02344 20.2925C2.02344 24.8917 3.85047 29.3026 7.1026 32.5547C10.3547 35.8069 14.7656 37.6339 19.3648 37.6339C23.964 37.6339 28.3749 35.8069 31.627 32.5547ZM19.3648 13.7897V26.7954M12.862 20.2925H25.8676",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.351679977fc2f779bfb457fcc2db7afa.svg";
export { ForwardRef as ReactComponent };